import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import UserAccountTab from './userAccountTab';
import UserPersonalDataTab from './userPersonalDataTab';
import UserChangePasswordTab from './userChangePasswordTab';
import UserInformationTab from './userInformationTab';
import { Accordion, AccordionTab } from 'primereact/accordion';

interface IProps {
  history: any
}

interface IState {
  isLoading: boolean;
  activeIndex: any;
}

class UserProfileComponent extends React.Component<IProps, IState> {

  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      activeIndex: null
    };
  }

  componentDidMount() {
  }

  handleTabMenuchange = (event, value) => {
    if (value != null) {
      this.setState({ activeIndex: value });
    } else {
      this.setState({ activeIndex: null });
    }
  }

  onCancelClick = () => {
    {
      this.setState({ activeIndex: null });
    }
  }

  onSave = () => {
    //Function is empty because we need props.onSave
    //in user family to close the popup, here we 
    //don't need it but if is not iplemented there is a error
  }

  public render() {
    const { isLoading, activeIndex } = this.state;

    return (
      <div className="app-content">

        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h1>{Translate('Profile')}</h1>

        <div>
          <Accordion activeIndex={activeIndex} onTabChange={(e) => this.handleTabMenuchange(e, e.index)}>
            <AccordionTab header={Translate('Account')}>
              {activeIndex == 0 ?
                <UserAccountTab history={this.props.history} onCancelClick={this.onCancelClick}></UserAccountTab>
                : null}
            </AccordionTab>
            <AccordionTab header={Translate('Personal Data')}>
              {activeIndex == 1 ?
                <UserPersonalDataTab history={this.props.history} onCancelClick={this.onCancelClick} onSave={this.onSave}></UserPersonalDataTab>
                : null}
            </AccordionTab>
            <AccordionTab header={Translate('Change Password')}>
              {activeIndex == 2 ?
                <UserChangePasswordTab history={this.props.history} onCancelClick={this.onCancelClick}></UserChangePasswordTab>
                : null}
            </AccordionTab>
            <AccordionTab header={Translate('Your Information')}>
              {activeIndex == 3 ?
                <UserInformationTab></UserInformationTab>
                : null}
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    )
  }
}

export default UserProfileComponent;